// Adapts the CDS multi-select SelectChip onChange to a React array-state setter.
export function makeChipFilterChange<T>(setter: (update: T[] | ((prev: T[]) => T[])) => void) {
  return (value: T | T[] | null) => {
    if (value === null) {
      setter([]);
      return;
    }

    if (Array.isArray(value)) {
      setter((prev) => {
        const valuesToKeep = prev.filter((currentValue) => !value.includes(currentValue));
        const valuesToAdd = value.filter((nextValue) => !prev.includes(nextValue));
        return [...valuesToKeep, ...valuesToAdd];
      });
      return;
    }

    setter((current) =>
      current.includes(value)
        ? current.filter((currentValue) => currentValue !== value)
        : [...current, value],
    );
  };
}
